import { emailBlacklist } from "../resource/emailBlacklist";
export const ValidationMixin = {
  methods: {
    updateValidation(field, valid = null, message = null) {
      if (valid) {
        this.$formFrameworkOptions.formBus.fields[field].validationIcon = "fas fa-check";
        this.$formFrameworkOptions.formBus.fields[field].valid = true;
      } else if (valid === false) {
        this.$formFrameworkOptions.formBus.fields[field].validationIcon = "fas fa-times";
        this.$formFrameworkOptions.formBus.fields[field].valid = false;
      } else {
        this.$formFrameworkOptions.formBus.fields[field].validationIcon = "";
        this.$formFrameworkOptions.formBus.fields[field].valid = null;
      }
      this.$formFrameworkOptions.formBus.fields[field].validationMessage = message;
    },
    resetValidation(field, val) {
      this.$formFrameworkOptions.formBus.fields[field].valid = null;
      this.$formFrameworkOptions.formBus.fields[field].validationMessage = null;
      this.$formFrameworkOptions.formBus.fields[field].validationIcon = null;
    },
    updateMobileNumberValidation(valid) {
      if (this.$formFrameworkOptions.formBus.fields.mobileNumber.value === '') {
        return;
      }
      let message = ''
      if (!valid) {
        message = 'Please enter a valid phone number';
      }
      this.updateValidation("mobileNumber", valid, message);
    },
    validateCountry(val) {
      if (val !== 'ZA') {
        this.$formFrameworkOptions.formBus.fields['country'].validationIcon = 'fas fa-exclamation-triangle'
        this.$formFrameworkOptions.formBus.fields['country'].valid = true
        this.$formFrameworkOptions.formBus.fields['country'].validationMessage = 'We are currently not in your region. Use of our product will be limited to our virtual economy solution. We\'ll keep you on record and communicate with you about future releases in your region.';
      } else {
        this.updateValidation('country', true)
      }
    },
    isWorkEmail(email) {
      //Check that the email address is not at a non-work domain
      const emailDomain = email.replace(/.*@/, "");
      if (
        emailBlacklist.find(invalidDomain => invalidDomain === emailDomain) !==
        undefined
      ) {
        return false;
      }
      return true;
    }
  }
};